<template>
  <div>
    <DxPopup
      :visible="popupVisible"
      :drag-enabled="true"
      :hide-on-outside-click="false"
      :show-title="true"
      :width="'65%'"
      :height="310"
      title="Edit Item"
      :ref="'edit-item-popup'"
      @hidden="popupHidden"
      @shown="popupShown"
      :showCloseButton="false"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <DxToolbarItem
        :options="this.searchOptions"
        widget="dxButton"
        location="after"
      ></DxToolbarItem>

      <GcPopUpSearchForItem
        v-if="searchForItem && searchForItem.visible"
        :setVisible="searchForItem.visible"
        :callBack="searchForItem.popUpCallBack"
        :searchForItem="searchForItem.searchForItemData"
        :productListQuery="
          searchForItem.productListQuery
            ? searchForItem.productListQuery
            : undefined
        "
        :productListColumns="
          searchForItem.columns ? searchForItem.columns : undefined
        "
        :baseView="baseView"
      ></GcPopUpSearchForItem>

      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getFormItems"
          :formHeight="185"
          :isNormal="true"
          :data-model="formDataModel"
          :formMode="'create'"
          :validationGroup="'gcPopupConfig-gc-popup-form-data'"
          :formTitle="'gc-popup'"
          :ref="'edit-item-popup-form'"
        ></gc-form>
      </div>

      <div class="footer edit-product-item-popup-footer">
        <DxButton
          text="Update"
          type="default"
          styling-mode="contained"
          class="save-btn"
          @click="saveEditProductItem()"
          :disabled="saveDisabled"
          :ref="'footer-save-btn'"
        />
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          class="cancel-btn"
          @click="popupHidden"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import ApiService from "../_services/api/api.service";
import BaseViewMixin from "../v1/_mixins/base.view";
import { SalesOrderService } from "../_services/api/sales/sales-order.service";
import { PurchaseOrder } from "../_services/api/purchasing/purchase-order.service";

export default {
  props: {
    setVisible: Boolean,
    callBack: {
      type: Function,
      default: function () {},
    },
    editProductItemData: Object,
    setLoading: {
      type: Function,
      default: function () {},
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      CellValueChanged: false,
      toolBarHeight: 0,
      originalItem: {
        Code: "",
        SalesUM: "",
        SalesUMQty: "",
        Price: "",
        Discount: "",
        Comment: "",
      },
      formDataModel: {
        OldCode: "",
        OldDescription: "",
        Code: "",
        Description: "",
        SalesUM: "",
        SalesUMQty: "",
        SalesTaxPcnt: "",
        Price: "",
        Discount: "",
        Amount: "",
        Comment: "",
      },
      saveDisabled: true,
      searchForItem: undefined,
      searchOptions: {
        text: "Search Item",
        type: "default",
        stylingMode: "contained",
        onClick: this.searchForProductItem,
      },
      invalidItemCode: false,
      // orderType will control the flow of logic
      // so = it will follow the flow related to sales order
      // gi = it will follow the flow related to goods in
      orderType: "so", // so (sales order), gi (goods in)
      selectedProduct: undefined,
    };
  },
  async created() {
    if (this.editProductItemData.orderType != undefined) {
      this.orderType = this.editProductItemData.orderType.toLowerCase();
    }

    this.originalItem.Code = this.editProductItemData.ItemCode;
    this.originalItem.SalesUM = this.editProductItemData.SalesUM;
    this.originalItem.SalesUMQty = this.editProductItemData.SalesUMOrderQty;
    this.originalItem.Price = this.editProductItemData.SalesUMFXPrice;
    this.originalItem.Discount = this.editProductItemData.DiscPcnt;
    this.originalItem.SalesTaxPcnt = this.editProductItemData.SalesTaxPcnt;
    this.originalItem.Comment = this.editProductItemData.Comment;

    this.formDataModel.OldCode = this.editProductItemData.ItemCode;
    this.formDataModel.OldDescription =
      this.editProductItemData.ItemDescription;
    this.formDataModel.Code = this.editProductItemData.ItemCode;
    this.formDataModel.SalesUM = this.editProductItemData.SalesUM;
    this.formDataModel.SalesUMQty = this.editProductItemData.SalesUMOrderQty;
    this.formDataModel.Price = this.editProductItemData.SalesUMFXPrice;
    this.formDataModel.Description = this.editProductItemData.ItemDescription;
    this.formDataModel.SalesTaxPcnt = this.editProductItemData.SalesTaxPcnt;
    this.formDataModel.Discount = this.editProductItemData.DiscPcnt;
    this.formDataModel.Comment = this.editProductItemData.Comment;
    this.formDataModel.ItemType = this.editProductItemData.ItemType;
    this.formDataModel.TaxCode = this.editProductItemData.TaxCode;
    if (this.editProductItemData.TaxInclusiveLineFXTotal != undefined) {
      this.formDataModel.Amount =
        this.editProductItemData.TaxInclusiveLineFXTotal;
    } else {
      this.formDataModel.Amount =
        this.formDataModel.SalesUMQty *
        this.formDataModel.Price *
        ((100.0 - this.formDataModel.Discount) / 100.0);
      this.formDataModel.Amount =
        this.formDataModel.Amount +
        this.formDataModel.Amount * (this.formDataModel.SalesTaxPcnt / 100);
      this.formDataModel.Amount = this.formDataModel.Amount.roundNumber(2);
    }
    this.formDataModel.ID = this.editProductItemData.ID;
  },
  computed: {
    popupVisible() {
      return this.setVisible ? true : false;
    },
    getSalesUMExpr() {
      if (this.orderType == "gi") {
        return "SupplierUM";
      } else {
        return "UnitOfMeasureCode";
      }
    },
    getSalesUMDataSourceConfig() {
      if (this.orderType == "so") {
        return {
          endpoint: "api/ProductUnitOfMeasure",
          filter: [
            ["ProductCode", "=", this.formDataModel.Code],
            ["BranchCode", "=", this.editProductItemData.BranchCode],
          ],
        };
      } else if (this.orderType == "gi") {
        return {
          endpoint: "api/ProductPurchaseList",
          filter: [
            ["ProductCode", "=", this.formDataModel.Code],
            ["SupplierCode", "=", this.editProductItemData.SupplierCode],
          ],
        };
      } else {
        return null;
      }
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Code",
                  label: {
                    text: "Current Item",
                  },
                  dataField: "OldCode",
                  editorOptions: {
                    allowUpdate: false,
                  },
                  colSpan: 1,
                },
                {
                  screenField: "Code",
                  editorType:
                    this.orderType == "gi" ? "dxSelectBox" : "dxTextBox",
                  label: {
                    text: "New Item",
                  },
                  dataField: "Code",
                  editorOptions: {
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    allowUpdate: true,
                    onValueChanged: async (e) => {
                      if (e.event) {
                        await this.updateFormModel(this.formDataModel.Code);
                        if (this.invalidItemCode) {
                          this.$refs["edit-item-popup-form"].$refs[
                            "gc-form-comp"
                          ].instance
                            .getEditor("Code")
                            .focus();
                        } else {
                          setTimeout(() => {
                            if (this.orderType == "so") {
                              this.$refs["edit-item-popup-form"].$refs[
                                "gc-form-comp"
                              ].instance
                                .getEditor("SalesUM")
                                .focus();
                            } else if (this.orderType == "gi") {
                              this.$refs["edit-item-popup-form"].$refs[
                                "gc-form-comp"
                              ].instance
                                .getEditor("SalesUMQty")
                                .focus();
                            }
                          }, 10);
                        }
                      }
                    },
                    dataSource: PurchaseOrder.dataSourceConfig(
                      "api/ProductPurchaseList",
                      {
                        filter: [
                          [
                            "SupplierCode",
                            "=",
                            `${this.editProductItemData.SupplierCode}`,
                          ],
                        ],
                      }
                    ),
                    displayExpr: "ProductCode",
                    valueExpr: "ProductCode",
                    searchTimeout: 10,
                    searchEnabled: true,
                    searchExpr: [
                      "ProductCode",
                      "PurchaseDescription1",
                      "ProductDescription1",
                    ],
                    onSelectionChanged: (e) => {
                      this.onProductCodeSelected(e);
                    },
                    itemTemplate: (data) => {
                      return ` <div class="custom-auto-complete" id="${data.ProductCode}" >
                            <span class="auto-complete-primary">
                              ${data.ProductCode}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.PurchaseDescription1}
                            </span> 
                          </div>`;
                    },
                    dropDownOptions: {
                      minWidth: 400,
                    },
                  },
                },
                {
                  screenField: "SalesUM",
                  dataField: "SalesUM",
                  cellTemplate: "Record",
                  gridDataField: "SalesUM",
                  cellTemplateRecord: {
                    primary: [
                      {
                        dataField: "SalesUM",
                      },
                    ],
                  },
                  editorOptions: {
                    onValueChanged: (e) => {
                      if (e.event) {
                        this.salesUMValueChanged();
                      }
                    },
                    allowUpdate: this.orderType == "so",
                    onKeyDown: (e) => {
                      this.goToNextField(e, "SalesUMQty");
                    },
                  },
                  dataSourceConfig:
                    this.orderType == "so"
                      ? this.getSalesUMDataSourceConfig
                      : undefined,
                  valueExpr: this.getSalesUMExpr,
                  displayExpr: this.getSalesUMExpr,
                  formField: {
                    label: "UM",
                    dataField: "SalesUM",
                  },
                },
                {
                  screenField: "SalesUMQty",
                  dataField: "SalesUMQty",
                  editorOptions: {
                    allowUpdate: true,
                    search: true,
                    onValueChanged: (e) => {
                      if (e.event) {
                        this.saleValueChanged();
                      }
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    onKeyDown: (e) => {
                      this.goToNextField(e, "Price");
                    },
                  },
                },
                {
                  screenField: "Price",
                  dataField: "Price",
                  format: "Decimal-16-2",
                  allowUpdate: true,
                  editorOptions: {
                    onValueChanged: (e) => {
                      if (e.event) {
                        this.saleValueChanged();
                      }
                    },
                    format: "Decimal-16-2",
                    onKeyDown: (e) => {
                      if (this.orderType != "gi")
                        this.goToNextField(e, "Discount");
                      else this.goToNextField(e, "SalesTaxPcnt");
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                },
                {
                  screenField: "DiscountPercent",
                  dataField: "Discount",
                  allowUpdate: true,
                  visible: this.orderType != "gi",
                  editorOptions: {
                    allowUpdate: true,
                    search: true,
                    onValueChanged: (e) => {
                      if (e.event) {
                        this.saleValueChanged();
                      }
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    onKeyDown: (e) => {
                      if (this.orderType == "gi")
                        this.goToNextField(e, "SalesTaxPcnt");
                      else this.goToNextField(e, "Comment");
                    },
                  },
                },
                {
                  screenField: "TaxPercent",
                  dataField: "SalesTaxPcnt",
                  allowUpdate: true,
                  visible: this.orderType == "gi",
                  editorOptions: {
                    allowUpdate: true,
                    search: true,
                    onValueChanged: (e) => {
                      if (e.event) {
                        this.saleValueChanged();
                      }
                    },
                    onKeyDown: (e) => {
                      this.goToNextField(e, "Comment");
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                },
                {
                  screenField: "Amount",
                  dataField: "Amount",
                  editorOptions: {
                    format: "Decimal-16-2",
                    allowUpdate: false,
                  },
                  label: {
                    text: "Total",
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Description",
                  label: {
                    text: " ",
                  },
                  dataField: "OldDescription",
                  editorOptions: {
                    allowUpdate: false,
                  },
                },
                {
                  screenField: "Description",
                  dataField: "Description",
                  editorOptions: {
                    allowUpdate: false,
                  },
                  label: {
                    text: " ",
                  },
                },
                {
                  screenField: "Comment",
                  dataField: "Comment",
                  editorOptions: {
                    onValueChanged: () => {
                      this.setSaveDisabled(!this.itemHasChanged());
                    },
                    onKeyDown: (e) => {
                      if (
                        e.event.key == "Enter" ||
                        (e.event.key == "Tab" && e.event.shiftKey == false)
                      ) {
                        setTimeout(() => {
                          var btn = this.$refs["footer-save-btn"];
                          btn.instance.focus();
                        }, 1);
                      }
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },
  watch: {},
  methods: {
    goToNextField(e, dataField) {
      if (
        e.event.key == "Enter" ||
        (e.event.key == "Tab" && e.event.shiftKey == false)
      ) {
        setTimeout(() => {
          this.$refs["edit-item-popup-form"].$refs["gc-form-comp"].instance
            .getEditor(dataField)
            .focus();
        }, 1);
      }
    },
    onProductCodeSelected(e) {
      this.selectedProduct = e.selectedItem;
    },
    // returns true if they are the same
    itemHasChanged() {
      if (this.originalItem.Code != this.formDataModel.Code) {
        return true;
      }
      if (this.originalItem.SalesUM != this.formDataModel.SalesUM) {
        return true;
      }
      if (this.originalItem.SalesUMQty != this.formDataModel.SalesUMQty) {
        return true;
      }
      if (this.originalItem.Price != this.formDataModel.Price) {
        return true;
      }
      if (this.originalItem.Discount != this.formDataModel.Discount) {
        return true;
      }
      if (this.originalItem.SalesTaxPcnt != this.formDataModel.SalesTaxPcnt) {
        return true;
      }
      if (this.originalItem.Comment != this.formDataModel.Comment) {
        return true;
      }
      return false;
    },
    searchForProductItem() {
      let query = undefined;
      let columns = undefined;
      if (this.orderType == "gi") {
        query = {
          endpoint: "ProductPurchaseList",
          select: ["ProductCode", "PurchaseDescription1"],
          filter: [
            ["SupplierCode", "=", `${this.editProductItemData.SupplierCode}`],
          ],
          serverPaging: true,
          allowGrouping: false,
        };

        columns = [
          {
            screenField: "Code",
            label: "Product",
            dataField: "ProductCode",
          },
          {
            screenField: "ItemDescription",
            label: "Description",
            dataField: "PurchaseDescription1",
          },
        ];
      }
      this.searchForItem = {
        visible: true,
        popUpCallBack: this.searchForItemCallBack,
        productListQuery: query,
        columns: columns,
      };
    },
    searchForItemCallBack(item, updated) {
      if (updated) {
        if (this.orderType == "gi") {
          item.Code = item.ProductCode;
        }
        this.formDataModel.Code = item.Code;
        this.updateFormModel(item.Code);
      }
      this.searchForItem = undefined;
    },
    setSaveDisabled(state) {
      this.saveDisabled = state;
    },
    popupHidden() {
      this.callBack(false);
    },
    popupShown() {
      setTimeout(() => {
        this.$refs["edit-item-popup-form"].$refs["gc-form-comp"].instance
          .getEditor("Code")
          .focus();
      }, 10);
    },
    async saveSalesOrderItem() {
      this.setSaveDisabled(true);
      this.setLoading(true);

      await ApiService.post("api/Save_SalesOrderDetailSingle", {
        DiscPcnt: this.formDataModel.Discount,
        Comment: this.formDataModel.Comment,
        ItemCode: this.formDataModel.Code,
        LineNo: this.editProductItemData.LineNo,
        SalesOrderCode: this.editProductItemData.SalesOrderCode,
        SalesUM: this.formDataModel.SalesUM,
        SalesUMPrice: this.formDataModel.Price,
        SalesUMQty: this.formDataModel.SalesUMQty,
      })
        .then(() => {
          this.$notify("Successfully edited item.", "Success");
          this.setLoading(false);
          this.setSaveDisabled(true);
          this.callBack(this.formDataModel);
        })
        .catch(() => {
          this.$notify(
            "Failed to edit item. The item may have been part picked.",
            "error"
          );
          this.setLoading(false);
          this.setSaveDisabled(true);
          this.callBack(false);
        });
    },
    async saveGoodsInItem() {
      this.setSaveDisabled(true);
      this.setLoading(true);

      await ApiService.post("api/Save_PurchaseOrderAddLine", {
        PurchaseOrderCode: this.editProductItemData.PurchaseOrderCode,
        BranchCode: this.editProductItemData.BranchCode,
        DivisionCode: this.editProductItemData.DivisionCode,
        ItemType: this.formDataModel.ItemType,
        ItemCode: this.formDataModel.Code,
        SupplierRequired: this.formDataModel.SalesUMQty,
        FXPrice: this.formDataModel.Price,
        Comment: this.formDataModel.Comment,
        TaxCode: this.formDataModel.TaxCode,
        TaxPcnt: this.formDataModel.SalesTaxPcnt,
        DiscPcnt: this.formDataModel.Discount,
        ETADate: this.editProductItemData.ETADate,
        RequiredByDate: this.editProductItemData.RequiredByDate,
        LineNo: `${this.editProductItemData.ID}`,
      })
        .then(() => {
          this.$notify("Successfully edited item.", "Success");
          this.setLoading(false);
          this.setSaveDisabled(true);
          this.callBack(true);
        })
        .catch(() => {
          this.$notify(
            "Failed to edit item. The item may have been part picked.",
            "error"
          );
          this.setLoading(false);
          this.setSaveDisabled(true);
          this.callBack(false);
        });

      this.setLoading(false);
    },
    async saveEditProductItem() {
      if (this.orderType == "so") {
        this.saveSalesOrderItem();
      } else if (this.orderType == "gi") {
        this.saveGoodsInItem();
      }
    },
    async salesUMValueChangedSO() {
      var dateIn = new Date(this.editProductItemData.DateIn);
      const salesItemParams = {
        TransactionDate: dateIn.toFilterDateString(),
        SalesOrderTypeCode: this.editProductItemData.SalesOrderType,
        BranchCode: this.editProductItemData.BranchCode,
        CustomerCode: this.editProductItemData.CustomerCode,
        ExchangeRate: this.editProductItemData.ExchangeRate,
        ItemType: this.editProductItemData.ItemType,
        ItemCode: this.formDataModel.Code,
        SalesUM: this.formDataModel.SalesUM,
        SalesUMQty: this.formDataModel.SalesUMQty,
      };
      var saleItemPriceData = await SalesOrderService.getSaleItemPrice(
        salesItemParams
      );
      this.formDataModel.SalesUM = saleItemPriceData.data.SalesUM;
      this.formDataModel.SalesUMQty = saleItemPriceData.data.SalesUMQty;
      this.formDataModel.Price = saleItemPriceData.data.SalesUMFXPrice;
      this.formDataModel.Discount = saleItemPriceData.data.DiscPcnt;
      this.formDataModel.SalesTaxPcnt = saleItemPriceData.data.SalesTaxPcnt;
      this.formDataModel.Amount =
        this.formDataModel.SalesUMQty *
        this.formDataModel.Price *
        ((100.0 - this.formDataModel.Discount) / 100.0);
      this.formDataModel.Amount =
        this.formDataModel.Amount +
        this.formDataModel.Amount * (this.formDataModel.SalesTaxPcnt / 100);
      this.formDataModel.Amount = this.formDataModel.Amount.roundNumber(2);
      this.setSaveDisabled(!this.itemHasChanged());
    },
    async salesUMValueChanged() {
      if (this.orderType == "so") {
        this.salesUMValueChangedSO();
      }
    },
    async saleValueChanged() {
      this.formDataModel.Amount =
        this.formDataModel.SalesUMQty *
        this.formDataModel.Price *
        ((100.0 - this.formDataModel.Discount) / 100.0);
      this.formDataModel.Amount =
        this.formDataModel.Amount +
        this.formDataModel.Amount * (this.formDataModel.SalesTaxPcnt / 100.0);
      this.setSaveDisabled(!this.itemHasChanged());
    },
    async getProductDetails(itemCode, branchCode) {
      const productDataUrl = {
        url: "api/LineItemData",
        top: "1",
        filter: `Code eq '${itemCode}' and BranchCode eq '${branchCode}' and IsDefault eq 'Y'`,
      };

      var productDetails = undefined;
      await ApiService.oDataGet(productDataUrl)
        .then((res) => {
          if (res.data.value.length > 0) {
            productDetails = res.data.value;
          }
        })
        .catch(() => {});

      return productDetails;
    },
    async updateFormModelSO(itemCode) {
      this.setLoading(true);
      var productDetails = await this.getProductDetails(
        itemCode,
        this.editProductItemData.BranchCode
      );

      if (productDetails == undefined) {
        await this.$alert(
          `Product ${this.formDataModel.Code} does not exist.`,
          "Warning"
        );
        this.formDataModel.Code = this.originalItem.Code;
        this.formDataModel.SalesUM = this.originalItem.SalesUM;
        this.setSaveDisabled(!this.itemHasChanged());
        this.invalidItemCode = true;
        this.setLoading(false);
        return;
      } else {
        this.invalidItemCode = false;
        var dateIn = new Date(this.editProductItemData.DateIn);
        const salesItemParams = {
          TransactionDate: dateIn.toFilterDateString(),
          SalesOrderTypeCode: this.editProductItemData.SalesOrderType,
          BranchCode: this.editProductItemData.BranchCode,
          CustomerCode: this.editProductItemData.CustomerCode,
          ExchangeRate: this.editProductItemData.ExchangeRate,
          ItemType: this.editProductItemData.ItemType,
          ItemCode: itemCode,
          SalesUM: productDetails[0].UnitOfMeasureCode,
          SalesUMQty: this.formDataModel.SalesUMQty,
        };

        var saleItemPriceData = await SalesOrderService.getSaleItemPrice(
          salesItemParams
        );

        this.formDataModel.Code = itemCode;
        this.formDataModel.SalesUM = saleItemPriceData.data.SalesUM;
        this.formDataModel.SalesUMQty = saleItemPriceData.data.SalesUMQty;
        this.formDataModel.Price = saleItemPriceData.data.SalesUMFXPrice;
        this.formDataModel.Description = productDetails[0].Description;
        this.formDataModel.Discount = saleItemPriceData.data.DiscPcnt;
        this.formDataModel.SalesTaxPcnt = saleItemPriceData.data.SalesTaxPcnt;
        this.formDataModel.Amount =
          this.formDataModel.SalesUMQty *
          this.formDataModel.Price *
          ((100.0 - this.formDataModel.Discount) / 100.0);
        this.formDataModel.Amount =
          this.formDataModel.Amount +
          this.formDataModel.Amount * (this.formDataModel.SalesTaxPcnt / 100.0);
        this.formDataModel.Amount = this.formDataModel.Amount.roundNumber(2);
        this.setSaveDisabled(!this.itemHasChanged());
      }
      this.setLoading(false);
    },
    async getProductPurchaseData(itemCode, supplierCode) {
      const productPurchaseDataUrl = {
        url: "api/ProductPurchaseList",
        top: "1",
        filter: `SupplierCode eq '${supplierCode}' and ProductCode eq '${itemCode}'`,
      };

      var productDetails = undefined;

      await ApiService.oDataGet(productPurchaseDataUrl)
        .then((res) => {
          if (res.data.value.length > 0) {
            productDetails = res.data.value[0];
          }
        })
        .catch(() => {});

      return productDetails;
    },
    async updateFormModelGI(itemCode) {
      this.setLoading(true);
      // make sure the item code is a valid item code and is linked to the supplier
      let productData = this.selectedProduct
        ? this.selectedProduct
        : await this.getProductPurchaseData(
            itemCode,
            this.editProductItemData.SupplierCode
          );
      if (productData == undefined) {
        await this.$alert(
          `Product ${this.formDataModel.Code} does not exist.`,
          "Warning"
        );
        this.formDataModel.Code = this.originalItem.Code;
        this.formDataModel.SalesUM = this.originalItem.SalesUM;
        this.setSaveDisabled(!this.itemHasChanged());
        this.invalidItemCode = true;
        this.setLoading(false);
        return;
      } else {
        this.formDataModel.ItemType = productData.ItemType;
        this.formDataModel.TaxCode = productData.TaxCode;
        this.formDataModel.Code = productData.ProductCode;
        this.formDataModel.Description = productData.PurchaseDescription1;
        this.formDataModel.SalesUM = productData.SupplierUM;
        this.formDataModel.Price = productData.SupplierPrice;
        this.formDataModel.SalesTaxPcnt = productData.TaxPcnt;
        this.formDataModel.Discount = 0.0;
        this.formDataModel.Amount =
          this.formDataModel.SalesUMQty *
          this.formDataModel.Price *
          ((100.0 - this.formDataModel.Discount) / 100.0);
        this.formDataModel.Amount =
          this.formDataModel.Amount +
          this.formDataModel.Amount * (this.formDataModel.SalesTaxPcnt / 100.0);
        this.formDataModel.Amount = this.formDataModel.Amount.roundNumber(2);
        this.setSaveDisabled(!this.itemHasChanged());
      }

      this.selectedProduct = undefined;
      this.setLoading(false);
    },
    async updateFormModel(itemCode) {
      if (this.orderType == "so") {
        this.updateFormModelSO(itemCode);
      } else if (this.orderType == "gi") {
        this.updateFormModelGI(itemCode);
      }
    },
  },
};
</script>

<style lang="scss">
.edit-product-item-popup-footer {
  padding-top: 10px;
  bottom: 0;
  margin-right: 0px;
  height: 45px;
  text-align: right;

  .save-btn {
    margin-right: 10px;
    background-color: #8bc34a;
  }

  .cancel-btn {
    margin-right: 0px;
    background-color: #ff0033;
  }
}
</style>
